export type ConsentFlowStep = {
  /** i18n key — resolve at call site via intl.formatMessage({ id: step.labelKey }) */
  labelKey: string
  titleKey: string
  descriptionKey: string
}

export type ConsentFlowSteps = {
  consent: ConsentFlowStep
  secondary: ConsentFlowStep
  profile: ConsentFlowStep
}

/** PRACTITIONER_MEDIATED plus legacy typo PRACTIONER_MEDIATED from older client-config defaults. */
export function isPractitionerMediatedConsentFlow(consentFlow: string | null | undefined): boolean {
  const f = (consentFlow ?? '').trim().toUpperCase()
  return f === 'PRACTITIONER_MEDIATED' || f === 'PRACTIONER_MEDIATED'
}

export function isPrimaryConsentFlow(consentFlow: string | null | undefined): boolean {
  return (consentFlow ?? '').trim().toUpperCase() === 'PRIMARY'
}

export function buildConsentFlowSteps(consentFlow: string | null | undefined): ConsentFlowSteps {
  const practitionerMediated = isPractitionerMediatedConsentFlow(consentFlow)
  return {
    consent: {
      labelKey: 'consent.flow.consent.label',
      titleKey: 'consent.flow.consent.title',
      descriptionKey: 'consent.flow.consent.description',
    },
    secondary: {
      labelKey: practitionerMediated ? 'consent.flow.secondary.labelStep1' : 'consent.flow.secondary.labelStep2',
      titleKey: 'consent.flow.secondary.title',
      descriptionKey: 'consent.flow.secondary.description',
    },
    profile: {
      labelKey: practitionerMediated ? 'consent.flow.profile.labelStep2' : 'consent.flow.profile.labelStep3',
      titleKey: 'consent.flow.profile.title',
      descriptionKey: 'consent.flow.profile.description',
    },
  }
}
